import {
  DOCUMENT,
  Inject,
  Injectable,
  Renderer2,
  RendererFactory2,
} from "@angular/core";
import { environment } from "../../../../environments/environment";
import { CommonSubjectsService } from "../../../core/signals/common-subjects.service";

@Injectable({
  providedIn: "root",
})
export class KryptonStaticsLoaderService {
  static STATIC_FORM =
    "https://static.payzen.eu/static/js/krypton-client/V4.0/stable/kr-payment-form.min.js";

  static STATIC_CLASSIC =
    "https://static.payzen.eu/static/js/krypton-client/V4.0/ext/classic.js";

  static STATIC_CLASSIC_RESET =
    "https://static.payzen.eu/static/js/krypton-client/V4.0/ext/classic-reset.min.css";

  private renderer: Renderer2;

  constructor(
    private rendererFactory: RendererFactory2,
    @Inject(DOCUMENT) private document: Document,
    private commonSubjectsService: CommonSubjectsService
  ) {
    this.renderer = rendererFactory.createRenderer(null, null);
  }

  private loadScript(url: string, publicKey?: string): Promise<void> {
    return new Promise((resolve, reject) => {
      const script = this.renderer.createElement("script");
      script.src = url;
      script.type = "text/javascript";
      if (publicKey) {
        script.setAttribute("kr-public-key", publicKey);
      }
    //   // script.setAttribute(
    //   //   "kr-post-url-success",
    //   //   "https://pitts.app/thank-you/",
    //   // );
      script.onload = () => {
        resolve();
      };
      script.onerror = () => {
        reject(`Failed to load script: ${url}`);
      };
      this.renderer.appendChild(this.document.body, script);
    });
  }

  private loadStyles(url: string): Promise<void> {
    return new Promise((resolve, reject) => {
      const link = this.renderer.createElement("link");
      link.href = url;
      link.rel = "stylesheet";
      link.type = "text/css";
      link.onload = () => {
        resolve();
      };
      link.onerror = () => {
        reject(`Failed to load stylesheet: ${url}`);
      };
      this.renderer.appendChild(this.document.body, link);
    });
  }

  async loadStatics() {
    await Promise.all([
      this.loadScript(
        KryptonStaticsLoaderService.STATIC_FORM,
        environment.krPublicKey,
      ),
      this.loadScript(KryptonStaticsLoaderService.STATIC_CLASSIC),
      this.loadStyles(KryptonStaticsLoaderService.STATIC_CLASSIC_RESET),
    ]);
    this.commonSubjectsService.setIsDebugBar(true);
  }
}
